import React, { useEffect, useState } from "react";
import axios from "axios";
import PlaceHolderRnd from "./rnd";
import { useContext } from "react";
import { AppContext } from "component/context";
import { useNavigate } from "react-router-dom";
import { Domain } from "assets/lib/config";
import logo from "assets/logo/beelogo.png";

const AddPlaceHolders = () => {
  var timeId = Math.floor(Date.now() / 100);

  const [htmlString, setHtmlString] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [placeholders, setPlaceHolders] = useState([
    {
      id: timeId,
      img: "#",
      x: 350,
      y: window.pageYOffset + 50,
      height: 60,
      width: 100,
      backgroundColor: "#fef8d2"

    },
  ]);

  const [fun, setFun] = useContext(AppContext);

  let navigate = useNavigate();

  let urlString = window.location.href.split("/");
  let encodeId = urlString[urlString.length - 1];

  useEffect(() => {
    setLoading(true);
    setError("");
    axios
      .get(`/api/html/get/${encodeId}`)
      .then((res) => {
        setHtmlString(res?.data?.result?.html);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setError(err.response);
      });
  }, []);

  const addHtmlPlaceHolder = () => {
    setLoading(true);
    setError("");
    const template = document.createElement("template");
    template.innerHTML = htmlString;
    let wrapedDivHtml = `
    <div id="mainDiv" class="d-flex jc-center" style="display: flex; justify-content: center;">
      <div class="placeHolder-mainDiv-adjust" style="position: relative;">
        <div id="placeHoldersDivsParentDiv">
          <div>
          ${template.innerHTML}
          </div>
        </div>
      </div>
    </div>`;
    template.innerHTML = wrapedDivHtml;
    let signedDivs = document.querySelectorAll(".btn");
    for (let i = 0; i < signedDivs.length; i++) {
      let signedDiv = signedDivs[i];
      // template.content
      //   .querySelector("#placeHoldersDivsParentDiv")
      //   .append(signedDiv);

      if (signedDiv.className === "btn react-draggable react-draggable-dragged") {
        let signatureDiv = template.content.querySelector("#placeHoldersDivsParentDiv")
        // debugger
        let newDiv = signatureDiv.querySelectorAll(".btn")
        signatureDiv.append(signedDiv);
      }
      // let removeDiv = signedDivs
      //   .querySelector("#remove-overly-div")
      //   .remove();
    }

    let html = `<!DOCTYPE html>
    <html lang="he">
     <body>
 ${template.innerHTML}
     </body>
     </html>`;

    let data = {
      requestID: encodeId,
      html: html,
    };
    axios
      .post(`${Domain}/api/html/addPlaceholder`, data)
      .then((res) => {
        console.log(res);
        setLoading(false);
        navigate("/signature/complete");
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setError(err.response);
      });
  };

  const addNewPlaceHolder = () => {
    setPlaceHolders([
      ...placeholders,
      {
        id: timeId,
        img: "#",
        x: 350,
        y: window.pageYOffset + 50,
        height: 60,
        width: 100,
        backgroundColor: "#fef8d2"
      },
    ]);
  };

  useEffect(() => {
    setFun({
      ...fun,
      newPlaceHolder: addNewPlaceHolder,
      plcHldrFun: addHtmlPlaceHolder,
    });
  }, [placeholders, htmlString]);

  if (loading) {
    return (
      <div className="">
        <div style={{ height: "100px" }}></div>
        <div style={{ height: "80vh" }} className="d-flex jc-center ai-center">
          <div className="loader"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="d-flex jc-center ai-center" style={{ height: "100vh" }}>
        <div className="thank-you text-center d-flex jc-center flex-row ai-center" >
          <div style={{ textAlign: "center", marginBottom: "200px" }}>
            <h1>הוֹדָעָה</h1>
            <p>{error?.data?.message}</p>
          </div>
          <div className="thank-you2 d-flex gap-1">
            <div className="text-end">
              מעוניינים בחתימה אלקטרונית? <br /> מערכת הכוורת מאפשרת ניהול חכם כולל! <br /><a href="https://www.kaveret.biz">לחצו לפרטים</a>
            </div>
            <img width={150} alt="the bee" src={logo} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ height: "100px" }}></div>
      <div className="d-flex jc-center">
        <div className="placeHolder-mainDiv-adjust">
          {placeholders?.map((item, index) => (
            <div key={item.id}>
              <PlaceHolderRnd
                setPlaceHolders={setPlaceHolders}
                placeholders={placeholders}
                item={item}
                index={index}
              />
            </div>
          ))}
          <div
            id="create-html-to-pdf"
            dangerouslySetInnerHTML={{ __html: htmlString }}
          />
        </div>
      </div>
    </div >
  );
};

export default AddPlaceHolders;
